import { inject } from '@angular/core';
import { CanDeactivateFn, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { AppWizardService } from '../services/app-product.service';
import { OfferProductCardComponent } from '../components/cards/product-card/offer-product-card-component ';

export const productExitGuard: CanDeactivateFn<OfferProductCardComponent> = async (
	_component: OfferProductCardComponent,
	_currentRoute: ActivatedRouteSnapshot,
	_currentState: RouterStateSnapshot,
	nextState: RouterStateSnapshot
) => {
	const appWizardService = inject(AppWizardService);
	if (
		nextState.url.includes('product')
		// not in wizard session
		|| !appWizardService.getState().isValid
		// in wizard session and go back to wizard page
		|| (
			appWizardService.getState().isValid
			&& nextState.url.includes('wizard')
		)
	) {
		return true;
	}
	return appWizardService.actionExitWizard();
};
